import { Theme } from "@material-ui/core"
import FormControl from "@material-ui/core/FormControl"
import Grid from "@material-ui/core/Grid"
import InputLabel from "@material-ui/core/InputLabel"
import makeStyles from "@material-ui/core/styles/makeStyles"
import TextField from "@material-ui/core/TextField"
import React from "react"
import FieldSelect from "Components/Table/FieldSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import { useUpdate } from "./hooks"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme: Theme) => ({
    tagItem: {
        backgroundColor: "#00bcd4",
        padding: `4px 10px`,
        borderRadius: "14px",
        color: "white",
        margin: `10px ${theme.spacing(1)}px`,
        cursor: "pointer",
        boxSizing: "border-box",
        fontSize: 14,
        display: "inline-block",
        fontWeight: "bold",
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
    materialBtn: {
        display: "flex",
        justifyItems: "flex-start",
        alignItems: "center",
        marginTop: 20,
        marginLeft: -5,
    },
}))

const SpeciesUpdate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback, disabled,
        dialogData, text, isPass,
        handleChange, dateStr,
        external,
        handleChangeArticleType,
        editCallback,
    } = useUpdate()
    return (
        <BoardConfirmModal
            title="修改果壳自然备选"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            editCallback={editCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{dateStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    disabled={isPass}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item>
                <FormControl disabled={isPass} className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        rowData={{
                            species_article_type_id: external.articleTypeId,
                        }}
                        staticValueList={[]}
                        tableName="species_article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>
                <Grid item>
                    <div className={classes.materialBtn}>
                        <Button color="primary" onClick={editCallback}>编辑物料</Button>
                    </div>
                </Grid>
        </BoardConfirmModal>
    )
}

export default SpeciesUpdate
